import React from 'react'
import { useIntl } from 'react-intl'

type ProgressCardStep = {
  labelKey: string
  titleKey: string
  descriptionKey: string
}

type ProgressCardProps = {
  headingKey: string
  steps: ProgressCardStep[]
}

const ProgressCard: React.FC<ProgressCardProps> = ({ headingKey, steps }) => {
  const intl = useIntl()
  return (
    <section className="border-border-base w-full rounded-xl border bg-white px-5 py-6 font-sans shadow-sm sm:px-8">
      <h2 className="text-2xl leading-9 font-semibold tracking-tight text-[#002C22]">
        {intl.formatMessage({ id: headingKey })}
      </h2>
      <ol className="mt-6 space-y-7 border-l border-[#E4E7EC] pl-4">
        {steps.map((step) => (
          <li key={step.labelKey} className="relative">
            <span
              className="absolute top-[42px] -left-[23px] h-3 w-3 rounded-full border border-white bg-[#F2F4F7]"
              aria-hidden
            />
            <span className="border-border-base bg-background-secondary inline-flex rounded-full border px-2 py-1 text-xs font-medium text-[#002C22]">
              {intl.formatMessage({ id: step.labelKey })}
            </span>
            <h3 className="mt-3 text-base font-semibold text-[#002C22]">{intl.formatMessage({ id: step.titleKey })}</h3>
            <p className="text-text-body mt-2 text-sm leading-6">{intl.formatMessage({ id: step.descriptionKey })}</p>
          </li>
        ))}
      </ol>
    </section>
  )
}

export type { ProgressCardStep }
export default ProgressCard
